import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {
	QUERY_KEY_CAMERA_PHOTO_STATS,
	QUERY_KEY_CAMERA_PREVIEWS,
	QUERY_KEY_CAMERA_SNAPSHOT_DEVICES
} from '@containers/monitoringPlatform/photoFixation/queryHooks/constants/queryKey'
import {
	getCameraPhotoStatsApi,
	getCameraPreviewsApi,
	getCameraSnapshotDevicesApi
} from '@containers/monitoringPlatform/photoFixation/api/api'


export const useGetCameraSnapshotDevicesQuery = (
	accountId: number
) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getCameraSnapshotDevicesApi(accountId, onShowError),
		queryKey: [QUERY_KEY_CAMERA_SNAPSHOT_DEVICES, accountId?.toString()],
		staleTime: 1000 * 60 * 5,
		enabled: !!accountId,
		placeholderData: keepPreviousData,
	})
}

export const useGetCameraPhotoStatsQuery = (
	accountId: number
) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getCameraPhotoStatsApi(accountId, onShowError),
		queryKey: [QUERY_KEY_CAMERA_PHOTO_STATS, accountId?.toString()],
		staleTime: 1000 * 60 * 5,
		enabled: !!accountId,
		placeholderData: keepPreviousData,
	})
}

export const useGetCameraPreviewsQuery = (
	accountId: number
) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getCameraPreviewsApi(accountId, onShowError),
		queryKey: [QUERY_KEY_CAMERA_PREVIEWS, accountId?.toString()],
		staleTime: 1000 * 60 * 5,
		enabled: !!accountId,
		placeholderData: keepPreviousData,
	})
}
